module.exports = __webpack_public_path__ + "static/media/bsns-tracker.b196af17.png";